import { Button, Container, Grid } from "@mui/material";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useAuth from "hooks/use-auth";
import ImageZoom from "react-image-zooom";
import {
  getImagesColorProductRequest,
  getProductDetailsRequest,
} from "api/requests";
import {
  StyledAttributes,
  StyledAttributesCategory,
  StyledButton,
  StyledDetailsDescription,
  StyledDetailsDiv,
  StyledDetailsTitle,
  StyledMainBox,
  StyledMainDivSlider,
  StyledMainPaper,
  StyledPrice,
  StyledProductColorDiv,
  StyledSlideProductDiscount,
  StyledButtonisLoggedIn,
  StyledProductColorStock,
  StyledRadioBtn,
  StyledProductBeforePrice,
  StyledProductBeforeDiscountPriceDiv,
  StyledMain,
  StyledTitle,
  StyledSlider,
  StyledSlideProductDiv,
  StyledImgdiv,
  StyledTopdiv1,
  StyledTopdiv2,
  StyledStock,
  StyledStockCount,
  StyledquantityBox,
  StyledQuantityPicker,
  StyledButtonCheck,
  StyledButtonContainer,
  StyledBox,
} from "./ProductDetails.style";
import Tooltip from "@mui/material/Tooltip";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import notfound from "assets/img/notfound.png";
import MenuIcon from "@mui/icons-material/Menu";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MenuCM from "components/shared/menu";
import "./Details.css";
import Slider from "react-slick";
import spliter from "helper/digit-spliter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useHttp from "hooks/use-http";
import { Link, useParams } from "react-router-dom";
import LoadingCM from "components/shared/Loading";
import LoadingPartCM from "components/shared/PartLoading";
import SkeletonCM from "components/shared/Skeleton";
import SkeletonProductCM from "components/shared/Skeleton/product";

import { IMG_BASE_URL } from "constants";
import FooterCM from "components/shared/footer";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddToCartSchema } from "validations";
import Toast from "helper/toast";
import { addToShoppingCartRequest, NotifWhenAvailable } from "api/requests";
import ContactCM from "components/contactus";
import parse from "html-react-parser";
import ShareButton from "components/shared/ShareButton";
import CommentButton from "components/CommentButton";
import QuestionButton from "components/Q&a/QuestionButton";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

import {Helmet} from "react-helmet";

const skeleton = [1, 2, 3, 4];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2, pb: 2 }}>
          <div style={{ overflowY: "auto" }}>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowBackIosIcon
      className={className}
      style={{ ...style, display: "block", color: "#149ec4" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowForwardIosIcon
      className={className}
      style={{ ...style, display: "block", color: "#149ec4" }}
      onClick={onClick}
    />
  );
}

export default function AccessoryProductDetails() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [firstLoad, setFirstLoad] = useState(false);
  const params = useParams();
  const authCTX = useAuth();
  const { request, loading, setLoading } = useHttp();
  const {
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AddToCartSchema),
  });

  const [quantity, setQuantity] = useState(1);
  const [checked, setChecked] = useState(false);
  const [checkedStock, setCheckedStock] = useState(false);
  const [colorImages, setColorImages] = useState([]);

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [data, setData] = useState({
    productDetails: {
      productPrice: "",
      before_discount_price: "",
      product: [],
      similarProducts: [],
    },
  });

  //////////////// Slider Settings ////////////////
  let similarProductsSliderSettings = {
    // dots: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    // rtl: true,
    nextArrow: <SamplePrevArrow />,
    prevArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  let settings = {
    slidesToScroll: 1,
    arrows: false,
    focusOnselect: false,
    accessability: false,
    dot: true,
    infinite: true,
    speed: 300,
    cssEase: "Linear",
  };
  let settings2 = {
    arrows: false,
    direction: "rtl",
    focusOnselect: false,
    accessability: false,
    dot: true,
    infinite: colorImages[0]?.length > 2 ? true : false,
    speed: 300,
    cssEase: "Linear",
    responsive: [
      {
        breakpoint: 621,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const handleToggle = async (event) => {
    setChecked(event.target.value);
  };

  const handleLoginCheck = async (event) => {
    return Toast({
      type: "custom-warn",
      title: "برای خرید وارد حساب کاربری خود شوید",
    });
  };

  // const metaChange = (data) => {
  //   product_id = data.productDetails.product.id;
  //   product_name = data.productDetails.product.title;
  //   product_price = data.productDetails.product.price;
  //   product_old_price = data.productDetails.product.before_discount_price;
  //   availability =
  //     data.productDetails.product.stock == 0 ? "outofstock" : "instock";
  // };

  const getData = useCallback(async () => {
    let res = await request({
      url: getProductDetailsRequest,
      values: params.productId,
    });

    let slick = document.querySelector(".slick-track");
    slick.style.cssText += "transform: translate3d(0px, 0px, 0px);";
    if (res) {
      setColorImages([res.productDetails.product.color_images]);
      setData({
        productDetails: {
          productPrice: res.productDetails.product.price,
          before_discount_price:
            res.productDetails.product.before_discount_price,
          product: res.productDetails.product,
          similarProducts: res.productDetails.similarProducts,
        },
      });
      // metaChange(res);
    }
  }, [request, params.productId]);

  //////////////// get Color Images ////////////////
  const handleTakingPicturesOfOneColor = async (colorId) => {
    setQuantity(1);
    let colorIdImages = data?.productDetails?.product?.colors.filter(
      (color) => color.id === colorId
    );

    setColorImages([colorIdImages[0].images]);
    // console.log(colorImages[0].map(item => item.image));
  };

  const getPickerValue = (value) => {
    setQuantity(value);
  };

  const onSubmit = async (values) => {
    setQuantity(1);
    setFirstLoad(true);
    if (checked == false) {
      return Toast({
        type: "empty",
        title: "رنگ محصول ",
      });
    } else {
      let res = await request({
        url: addToShoppingCartRequest,
        values: {
          productColorId: checked,
          quantity: quantity,
        },
      });
      if (res) {
        return Toast({
          type: "success",
        });
      }
    }
  };

  const onSubmitAvailable = async (values) => {
    let res = await request({
      url: NotifWhenAvailable,
      values: {
        product_id: params.productId,
      },
    });
    if (res) {
      return Toast({
        type: "custom-success",
        title: "محصول موجود شد از طریق پیامک به شما اطلاع خواهیم داد",
        autoClose: 5000,
      });
    }
  };

  useEffect(() => {
    setColorImages([]);
    getData();
    setChecked(false);
    setCheckedStock(false);
    setQuantity(1);
  }, [getData]);

  return createPortal(
    <Fragment>
      <Helmet>
        <title>{data.productDetails.product.title}</title>
        <meta name="product_id" content={data.productDetails.product.id} />
        <meta name="product_name" content={data.productDetails.product.title} />
        <meta
          name="product_price"
          content={data.productDetails.product.price}
        />
        <meta
          name="product_old_price"
          content={data.productDetails.product.before_discount_price}
        />
        <meta
          name="availability"
          content={
            data.productDetails.product.stock == 0 ? "outofstock" : "instock"
          }
        />
        <meta
          property="og:image"
          content={IMG_BASE_URL + data.productDetails.product.image}
        />
      </Helmet>
      <>
        <MenuCM Detail />
        <StyledMainBox elevation={0}>
          <Container>
            <StyledMainPaper elevation={0}>
              <StyledTopdiv1>
                <StyledTopdiv2></StyledTopdiv2>
              </StyledTopdiv1>
              <Grid container spacing={2} direction="row">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <StyledMainDivSlider>
                    <div className="container mt-5 carousel">
                      <>
                        {loading && firstLoad == false ? (
                          <div style={{ paddingLeft: "10px" }}>
                            <SkeletonCM Height={400} BackWrapper />
                          </div>
                        ) : (
                          <Slider
                            {...settings}
                            asNavFor={nav2}
                            ref={(slider1) => setNav1(slider1)}
                          >
                            {colorImages[0]?.length < 1
                              ? ""
                              : colorImages[0]?.map((item, index) => (
                                  <div
                                    className="card-wrapper"
                                    key={"singleimage" + index}
                                  >
                                    <div className="card">
                                      <div className="card-image">
                                        <Zoom>
                                          <img
                                            className="image"
                                            src={IMG_BASE_URL + item.image}
                                            alt="عکس محصول"
                                          />
                                        </Zoom>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                          </Slider>
                        )}
                        {loading && firstLoad == false ? (
                          <div style={{ paddingLeft: "10px" }}>
                            <SkeletonCM Height={120} />
                          </div>
                        ) : (
                          <Slider
                            {...settings2}
                            asNavFor={nav1}
                            ref={(slider2) => setNav2(slider2)}
                            slidesToShow={3}
                            swipeToSlide={true}
                            focusOnSelect={true}
                          >
                            {colorImages[0]?.length < 1
                              ? ""
                              : colorImages[0]?.map((item, index) => (
                                  <div
                                    className="card-wrapper"
                                    key={"image" + index}
                                  >
                                    <div className="card2">
                                      <div className="card-image">
                                        <img
                                          className="image"
                                          src={IMG_BASE_URL + item.image}
                                          alt="عکس محصول"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                          </Slider>
                        )}
                      </>
                    </div>
                  </StyledMainDivSlider>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <StyledDetailsDiv>
                    <StyledDetailsTitle>
                      {loading && firstLoad == false ? (
                        <SkeletonCM />
                      ) : (
                        <> {data?.productDetails?.product?.title}</>
                      )}
                    </StyledDetailsTitle>
                    <StyledProductColorDiv>
                      {data?.productDetails?.product?.stock != 0 ? (
                        <FormControl>
                          {loading && firstLoad == false ? (
                            <SkeletonCM Height={37} Width={100} />
                          ) : (
                            <FormLabel id="demo-row-radio-buttons-group-label">
                              رنگ ها
                            </FormLabel>
                          )}

                          {loading && firstLoad == false ? (
                            <SkeletonCM
                              Circle
                              Inline
                              Width={40}
                              Height={40}
                              Count={4}
                              mLeft={10}
                              mTop={10}
                            />
                          ) : (
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                            >
                              {data?.productDetails?.product?.colors &&
                                data?.productDetails?.product?.colors.map(
                                  (color) => (
                                    <Tooltip
                                      title={`${color.title}`}
                                      key={"color" + color.id}
                                    >
                                      <StyledRadioBtn
                                        checked={
                                          checked == color.id ? true : false
                                        }
                                        // onChange={handleToggle}
                                        // onChange={setCheckedStock(color.stock)}
                                        onChange={(e) => {
                                          handleToggle(e);
                                          setCheckedStock(color.stock);
                                        }}
                                        value={color.id}
                                        disabled={
                                          color.stock == 0 ? true : false
                                        }
                                        style={{
                                          boxShadow: "0px 0px 1px 0px black",
                                          background: `${color.color_code}`,
                                          borderRadius: "50%",
                                          border:
                                            checked == color.id
                                              ? "4px solid #149ec4"
                                              : "4px solid transparent",
                                          display:
                                            color.stock == 0
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        onClick={() =>
                                          handleTakingPicturesOfOneColor(
                                            color.id
                                          )
                                        }
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 5,
                                            padding: 0.6,
                                          },
                                        }}
                                      />
                                    </Tooltip>
                                  )
                                )}
                            </RadioGroup>
                          )}
                        </FormControl>
                      ) : (
                        ""
                      )}
                    </StyledProductColorDiv>
                    <StyledProductColorStock></StyledProductColorStock>
                    {loading && firstLoad == false ? (
                      <SkeletonCM Height={37} Width={100} />
                    ) : (
                      <StyledAttributes>
                        <MenuIcon style={{ paddingLeft: 3 }} /> مشخصات :
                      </StyledAttributes>
                    )}
                    <StyledDetailsDescription>
                      {loading && firstLoad == false ? (
                        <SkeletonCM Count={6} Height={30} />
                      ) : (
                        <>
                          {/* {text == null ? "" : parse(text)} */}
                          {data?.productDetails?.product?.description == null
                            ? ""
                            : parse(data?.productDetails?.product?.description)}
                        </>
                      )}
                    </StyledDetailsDescription>
                    {loading && firstLoad == false ? (
                      <SkeletonCM Width={200} Height={40} />
                    ) : (
                      <>
                        {data?.productDetails?.product?.link ? (
                          <StyledAttributesCategory>
                            {" "}
                            <Button>
                              <a
                                href={`${data?.productDetails?.product?.link}`}
                                target="_blank"
                                style={{ color: "#009AC2" }}
                              >
                                در مورد محصول بیشتر بخوانید
                              </a>
                            </Button>
                          </StyledAttributesCategory>
                        ) : (
                          " "
                        )}
                      </>
                    )}

                    {checkedStock !== false && checkedStock <= 4 ? (
                      // <StyledStock>
                      //   <span>موجودی : </span> <span> {checkedStock} </span>
                      //   <span>عدد</span>
                      // </StyledStock>
                      <StyledStock>
                        <span>تنها</span> <span> {checkedStock} </span>
                        <span>عدد از این رنگ در انبار باقی مانده</span>
                      </StyledStock>
                    ) : (
                      ""
                    )}

                    {checkedStock !== false && checkedStock > 4 ? (
                      <StyledStockCount>
                        <span>موجودی : </span> <span> {checkedStock} </span>{" "}
                        <span> عدد </span>
                      </StyledStockCount>
                    ) : (
                      ""
                    )}

                    <StyledProductBeforeDiscountPriceDiv>
                      {loading && firstLoad == false ? (
                        <SkeletonCM Height={37} width={300} />
                      ) : (
                        <>
                          {data?.productDetails?.product?.discount_percent !==
                          0 ? (
                            <StyledProductBeforePrice>
                              <span>
                                {spliter(
                                  data?.productDetails?.before_discount_price
                                )}{" "}
                                تومان
                              </span>
                            </StyledProductBeforePrice>
                          ) : (
                            <p style={{ height: "26px", margin: "0" }}></p>
                          )}
                          {data?.productDetails?.product?.discount_percent !==
                          0 ? (
                            <StyledSlideProductDiscount>
                              {" "}
                              {
                                data?.productDetails?.product?.discount_percent
                              }{" "}
                              %{" "}
                            </StyledSlideProductDiscount>
                          ) : (
                            " "
                          )}
                        </>
                      )}
                    </StyledProductBeforeDiscountPriceDiv>

                    <StyledPrice>
                      {loading && firstLoad == false ? (
                        <SkeletonCM Height={37} Width={300} />
                      ) : (
                        <>
                          {data?.productDetails?.product?.stock != 0 ? (
                            <>
                              {" "}
                              قیمت:{" "}
                              {spliter(data?.productDetails?.productPrice)}{" "}
                              تومان
                            </>
                          ) : (
                            "محصول موجود نیست"
                          )}
                        </>
                      )}
                    </StyledPrice>
                    <div style={{ paddingLeft: "10px" }}>
                      {loading && firstLoad == false ? (
                        <SkeletonCM Height={50} />
                      ) : (
                        <StyledButtonContainer>
                          <>
                            <ShareButton ProductId={params.productId} />

                            {!authCTX.isLoggedIn ? (
                              <StyledButtonisLoggedIn
                                variant="contained"
                                onClick={handleLoginCheck}
                              >
                                خرید محصول{" "}
                                <AddShoppingCartOutlinedIcon
                                  style={{ marginRight: "6px" }}
                                />
                              </StyledButtonisLoggedIn>
                            ) : (
                              <>
                                {data?.productDetails?.product?.stock == 0 ? (
                                  <StyledButtonCheck
                                    variant="outlined"
                                    color="warning"
                                    onClick={handleSubmit(onSubmitAvailable)}
                                  >
                                    <NotificationsActiveIcon
                                      style={{ marginLeft: "6px" }}
                                    />
                                    موجود شد به من اطلاع بده{" "}
                                  </StyledButtonCheck>
                                ) : (
                                  <StyledquantityBox
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {checkedStock !== false ? (
                                      <>
                                        <StyledQuantityPicker
                                          value={1}
                                          min={1}
                                          max={checkedStock}
                                          smooth
                                          onChange={getPickerValue}
                                          width={"130px"}
                                        />
                                        {/* {quantity == 0 ? (
                                      ""
                                    ) : ( */}
                                        <StyledButton
                                          variant="contained"
                                          onClick={handleSubmit(onSubmit)}
                                          disabled={loading ? true : false}
                                        >
                                          {loading ? (
                                            <LoadingPartCM color="white" />
                                          ) : (
                                            "خرید محصول"
                                          )}{" "}
                                          <AddShoppingCartOutlinedIcon
                                            style={{ marginRight: "6px" }}
                                          />
                                        </StyledButton>
                                        {/* )} */}
                                      </>
                                    ) : (
                                      <StyledButtonCheck
                                        variant="contained"
                                        onClick={handleSubmit(onSubmit)}
                                      >
                                        خرید محصول{" "}
                                        <AddShoppingCartOutlinedIcon
                                          style={{ marginRight: "6px" }}
                                        />
                                      </StyledButtonCheck>
                                    )}
                                  </StyledquantityBox>
                                )}
                              </>
                            )}
                          </>
                        </StyledButtonContainer>
                      )}
                    </div>
                  </StyledDetailsDiv>
                </Grid>
              </Grid>

              <Grid container spacing={2} direction="row" pb={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {data?.productDetails?.similarProducts.length > 1 ? (
                    <StyledMain>
                      {loading && firstLoad == false ? (
                        <div style={{ textAlign: "center" }}>
                          <SkeletonCM Height={50} Width={200} mAuto />
                        </div>
                      ) : (
                        <StyledTitle>محصولات مشابه</StyledTitle>
                      )}
                      {loading && firstLoad == false ? (
                        <div>
                          <StyledSlider {...similarProductsSliderSettings}>
                            {skeleton.map((product, index) => (
                              <SkeletonProductCM key={index} />
                            ))}
                          </StyledSlider>
                        </div>
                      ) : (
                        <StyledSlider {...similarProductsSliderSettings}>
                          {data?.productDetails?.similarProducts.map(
                            (product, index) => (
                              <Link
                                to={`/product/${product.id}`}
                                key={"product" + index}
                              >
                                <StyledSlideProductDiv>
                                  <StyledImgdiv>
                                    {product.image == null ? (
                                      <img src={notfound} alt={product.title} />
                                    ) : (
                                      <img
                                        src={IMG_BASE_URL + product.image}
                                        alt={product.title}
                                      />
                                    )}
                                  </StyledImgdiv>
                                  <h2>{product.title}</h2>

                                  {product.discount_percent !== 0 ? (
                                    <p className="product-p">
                                      <span>
                                        {" "}
                                        {spliter(
                                          product?.before_discount_price
                                        )}{" "}
                                      </span>
                                      <span> تومان </span>
                                    </p>
                                  ) : (
                                    <p style={{ height: "26px" }}></p>
                                  )}
                                  <p>
                                    <span> {spliter(product.price)} </span>
                                    <span> تومان </span>
                                  </p>
                                  {product.discount_percent !== 0 ? (
                                    <StyledSlideProductDiscount
                                      style={{ position: "absolute" }}
                                    >
                                      {" "}
                                      {product.discount_percent} %{" "}
                                    </StyledSlideProductDiscount>
                                  ) : (
                                    " "
                                  )}
                                </StyledSlideProductDiv>
                              </Link>
                            )
                          )}
                        </StyledSlider>
                      )}
                    </StyledMain>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>

              <Grid container spacing={2} direction="row" pb={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <StyledBox
                    sx={{ width: "100%", direction: "ltr !important" }}
                  >
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab label="دیدگاه کاربران" {...a11yProps(0)} />
                        <Tab label="پرسش‌ ها" {...a11yProps(1)} />
                      </Tabs>
                    </Box>
                    <TabPanel
                      value={value}
                      index={0}
                      style={{ paddingLeft: "0px", paddingRight: "0px" }}
                    >
                      <CommentButton ProductId={params.productId} />
                    </TabPanel>
                    <TabPanel
                      value={value}
                      index={1}
                      style={{ paddingLeft: "0px", paddingRight: "0px" }}
                    >
                      <QuestionButton ProductId={params.productId} />
                    </TabPanel>
                  </StyledBox>
                </Grid>
              </Grid>
            </StyledMainPaper>
          </Container>
        </StyledMainBox>
        {data?.productDetails?.product?.design?.category.type == "اکسسوری" ? (
          <ContactCM Accessory />
        ) : (
          <ContactCM Furniture />
        )}

        <FooterCM />
      </>
    </Fragment>,
    document.getElementById("product_details")
  );
}
